import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { updateMetaTags } from '../utils/seo';
import Translate from '../components/Translate';
import PageBanner from '../components/PageBanner';

const ScreenReaderAccess = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        updateMetaTags(
            `${t('screen_reader')} | ${t('site-title')}`,
            t('screen-reader-desc'),
            t('screen-reader-keywords')
        );
    }, [t, i18n.language]);

    const screenReaders = [
        {
            name: t('reader-nvda'),
            website: "http://www.nvda-project.org/",
            type: t('screen-reader-type-free'),
        },
        {
            name: t('reader-jaws'),
            website: "http://www.freedomscientific.com/jaws-hq.asp",
            type: t('screen-reader-type-commercial'),
        },
        {
            name: t('reader-supernova'),
            website: "http://www.yourdolphin.co.uk/productdetail.asp?id=1",
            type: t('screen-reader-type-commercial'),
        },
        {
            name: t('reader-windoweyes'),
            website: "http://www.gwmicro.com/Window-Eyes/",
            type: t('screen-reader-type-commercial'),
        },
        {
            name: t('reader-hal'),
            website: "http://www.yourdolphin.co.uk/productdetail.asp?id=5",
            type: t('screen-reader-type-commercial'),
        },
        {
            name: t('reader-satogo'),
            website: "http://www.satogo.com/",
            type: t('screen-reader-type-free'),
        }
    ];

    return (
        <section className="w-full min-h-screen bg-primary-50/30 pb-16 text-left">
            <PageBanner
                title={<Translate text={'screen_reader'} />}
                subtitle={<Translate text={'screen-reader-subtitle'} />}
                badgeText={t('badge-accessibility-support')}
            />
            <div className="max-w-5xl mx-auto px-4 py-12 sm:px-6 lg:px-8 mt-12">
                <div className="bg-white rounded-[24px] shadow-sm border border-[#dadce0] overflow-hidden">
                    <div className="p-8 border-b border-gray-100 bg-gray-50/30">
                        <p className="text-gray-700 leading-relaxed text-sm mb-4">
                            {t('screen-reader-p1')}
                        </p>
                        <p className="text-gray-700 leading-relaxed text-sm">
                            {t('screen-reader-p2')}
                        </p>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50/50">
                                <tr>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">
                                        {t('screen-reader-header-name')}
                                    </th>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">
                                        {t('screen-reader-header-website')}
                                    </th>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">
                                        {t('screen-reader-header-type')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {screenReaders.map((reader, index) => (
                                    <tr key={index} className="hover:bg-primary-50/20 transition-colors">
                                        <td className="px-8 py-5 whitespace-nowrap text-sm font-bold text-gray-800">
                                            {reader.name}
                                        </td>
                                        <td className="px-8 py-5 text-sm text-blue-600">
                                            <a 
                                                href={reader.website} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="hover:text-primary-700 font-medium hover:underline inline-flex items-center gap-1"
                                            >
                                                {reader.website}
                                                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                                </svg>
                                            </a>
                                        </td>
                                        <td className="px-8 py-5 whitespace-nowrap text-sm text-gray-600">
                                            {reader.type}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
};



export default ScreenReaderAccess;
